import React from 'react';
import './TypePokemon.css';

const TypePokemon = props => {
    return(
        <div className="Element">
            <img id={props.name} className="Type" src={props.picture} alt="Element"/>
        </div>
    );
}

export default TypePokemon;